import { api } from '../api';
import { UpdateAppointmentDetailsRequestDTO } from '../../dtos/UpdateAppointmentDetailsRequestDTO';

export const updateAppointmentDetails = async ({
  anamnese,
  appointmentId,
  callStatus,
  icd,
  doctorObservation,
  observation,
  outcome,
}: UpdateAppointmentDetailsRequestDTO): Promise<number> => {
  // O campo do CID é `icd`, não `cid`: é o nome da coluna no `cinco-back` e o
  // que a resposta de agendamento devolve em `details.icd`. Enquanto isso aqui
  // mandava `cid`, o controller lia `icd` e o diagnóstico era descartado em
  // silêncio — e a leitura de `details.cid`, que não existe, nunca preenchia o
  // campo de volta.
  const { status } = await api.put('/appointments/appointmentDetails', {
    anamnese,
    appointmentId,
    callStatus,
    icd,
    doctorObservation,
    observation,
    outcome,
  });

  return status;
};
